export default __webpack_public_path__ + "static/media/Advanced Potion Making - BasedOn-02_03.910f0d92.jpg";